import { IntentInstallErrorCode, createIntentInstallError } from '../errors';
import { IntentInstallPanelsNames } from './ui/types';

// INFO: santa-editor build fails to resolve dynamic imports, so we keep it pre-defined for now

function importPanelModule(panelName: IntentInstallPanelsNames) {
  switch (panelName) {
    case IntentInstallPanelsNames.PreIntentInstallModal:
      return import('./ui/PreIntentInstallModal').then(
        (module) => module.PreIntentInstallModal,
      );
    case IntentInstallPanelsNames.WidgetAppsIntentInstallModal:
      return import('./ui/WidgetAppsIntentInstallModal').then(
        (module) => module.WidgetAppsIntentInstallModal,
      );
    default:
      throw createIntentInstallError(
        IntentInstallErrorCode.PanelComponentNotFound,
      ).withPanelName(panelName);
  }
}

export async function loadPanel(panelName: IntentInstallPanelsNames) {
  try {
    return await importPanelModule(panelName);
  } catch (e) {
    throw createIntentInstallError(
      IntentInstallErrorCode.FailedToLoadPanelComponent,
    )
      .withPanelName(panelName)
      .withParentError(e as Error);
  }
}
